import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import type { DetailsModel } from '@core/components/ui-clinng-status-alert/ui-clinng-status-alert.component';
import type { TicketDetails } from '@core/components/ui-clinng-ticket-info/ui-clinng-ticket-info.component';
import { UiClinngStaticHeaderComponent } from '@core/components/ui-clinng-static-header/ui-clinng-static-header.component';
import { UiClinngStatusAlertComponent } from '@core/components/ui-clinng-status-alert/ui-clinng-status-alert.component';
import { UiClinngTicketInfoComponent } from '@core/components/ui-clinng-ticket-info/ui-clinng-ticket-info.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'download-transfiya-voucher',
  standalone: true,
  imports: [
    CommonModule,
    UiClinngTicketInfoComponent,
    UiClinngStatusAlertComponent,
    MatToolbarModule,
    MatIconModule,
    UiClinngStaticHeaderComponent
  ],
  templateUrl: './download-transfiya-voucher.component.html',
  styleUrl: './download-transfiya-voucher.component.scss',
})
export class DownloadTransfiyaVoucherComponent {
  @Input() detailsModel!: DetailsModel;
  @Input() ticketDetails: TicketDetails[] = [];
  @Input() heightHeader: string = '';
  @Input() widthLogo: string = '';
  @Input() heightLogo: string = '';
}
